var Model = require('../Model');

var System = Object.create(Model);

System.name = 'System';
System['@class'] = 'System';
System.url = 'system';
System.fields = {
  name:{
    type: 'text',
    default: null,
  },
  parent:{
    type: 'text',
    default: '',
    validators: {
      presence: true,
    }
  },
  useGeoPositioning:{
    type: 'boolean',
    default: false,
  }
};

module.exports = System;